import dynamic from 'next/dynamic'
import { usePagePreview } from '~/context/page-preview'
import { useModal } from '~/components/modal'
import { useUpdateLogoMutation } from '~/pages/dashboard/graphql/update-logo'
import { useWorkspaceId } from '~/hooks/use-workspace-id'
import { refetchPageQuery } from '~/pages/dashboard/pages/fundaraising-pages-detail/graphql/page'

const PreviewPlaceholder = dynamic(
  () => import('~/pages/fundraising-page/components/preview-placeholder'),
  { ssr: false }
)
const ModalSelectImage = dynamic(
  () => import('~/pages/dashboard/components/modal-select-image'),
  { ssr: false }
)

type Props = {
  pageId: string
}

const PreviewLogo = ({ pageId }: Props) => {
  const workspaceId = useWorkspaceId()
  const context = usePagePreview()
  const modalSelectImage = useModal()

  const [updateLogo] = useUpdateLogoMutation({
    refetchQueries: [refetchPageQuery({ id: pageId })],
  })

  const handleImageSelect = async (url: string) => {
    await updateLogo({
      variables: {
        input: {
          workspaceId: workspaceId!,
          logoUrl: url,
        },
      },
    })
  }

  if (!context) {
    return null
  }

  return (
    <>
      <ModalSelectImage
        onImageSelect={handleImageSelect}
        width={560}
        {...modalSelectImage}
      />
      <PreviewPlaceholder
        onClick={modalSelectImage.show}
        height={40}
        width={280}
      >
        Upload Your Logo
      </PreviewPlaceholder>
    </>
  )
}

export default PreviewLogo
